<template>
  <div class="allocation-con">
    <StepsHeader :activeStep="activeStep"/>
    <div class="step-con">
      <Step1 v-if="activeStep===1"
             :orderData="sortedAllocationItemsById"
             :onNext="firstStepNextClick"/>
      <Step2 v-if="activeStep===2" :onNext="secondStepNextClick" :onBack="()=>goToStep(1)"
             :onCancel="stepCancelClick"/>
      <Step3 v-if="activeStep===3"
             :addresses="allocationData.addresses"
             :onNext="thirdStepNextClick"
             :onBack="()=>goToStep(2)"
             :onCancel="stepCancelClick"/>
      <Step4 v-if="activeStep===4"
             :onNext="fourthStepNextClick"
             :onBack="()=>goToStep(3)"
             :onCancel="stepCancelClick"/>
      <Step5 v-if="activeStep===5"
             :orderData="sortedAllocationItemsById"
             :onNext="fifthStepNextClick"
             :onBack="()=>goToStep(4)"
             :onCancel="stepCancelClick"/>
    </div>
    <LocalAllocationOrders v-if="localStorageData&&localStorageData.length>0"
                           :lineItems="allocationData.lineItems"
                           :localOrdersData="localStorageData"
                           :onFinishAllocated="finishAllocated"
                           :onDeleteItem="deleteLocalItem"
                           :onUpdateItem="updateLocalItem"
                           :errorArray="errorArray"
    />
    <AllocatedOrders :ordersData="allocationData.allocations"/>
    <UpdateLocalItemPopup v-if="popupVisible" :onSave="onSave" :onCancel="onCancel" :items="sortedAllocationItemsById" :currentAllocatedData="currentAllocatedData"/>
    <FinishAllocationPopup v-if="showFinishAllocationPopup" :onContinueClick="onContinueFinishAllocationPopup" :onClose="closeFinishAllocationPopup"/>
  </div>
</template>

<script>
import StepsHeader from './StepsHeader.vue';
import Step1 from './Step1.vue';
import Step2 from './Step2.vue';
import Step3 from './Step3.vue';
import Step4 from './Step4.vue';
import Step5 from './Step5.vue';
import {VueGoodTable} from 'vue-good-table';
import {sendOrder} from '../actions/Allocation';
import AllocatedOrders from "./AllocatedOrders.vue";
import LocalAllocationOrders from "./LocalAllocationOrders.vue";
import UpdateLocalItemPopup from "./UpdateLocalItemPopup.vue";
import FinishAllocationPopup from "./FinishAllocationPopup.vue";


export default {
  name: 'Allocation',
  props: {
    allocationData: Object
  },
  components: {
    UpdateLocalItemPopup,
    LocalAllocationOrders,
    AllocatedOrders,
    StepsHeader,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    VueGoodTable,
    FinishAllocationPopup
  },
  data() {
    return {
      activeStep: 1,
      localStorageData: null,
      poData: {
        po_required: false,
        po_number: '',
        poDate: ''
      },
      addressData: {},
      allocation_qty: [],
      canSend: true,
      popupVisible: false,
      updateItemIndex: 0,
      errorArray: [],
      showFinishAllocationPopup: false,
      currentAllocatedData: {}

    }
  },
  mounted() {
    this.getDataFromLocalStorage();
  },
  computed: {
    sortedAllocationItemsById(){
      return this.allocationData.lineItems.sort((a,b)=>{
        if (a.id < b.id) {
          return -1;
        }
        if (a.id > b.id) {
          return 1;
        }
        return 0;
      })
    }
  },
  methods: {
    firstStepNextClick() {
      this.activeStep = 2;
    },
    secondStepNextClick(data) {
      this.poData = data;
      this.activeStep = 3;
    },
    thirdStepNextClick(data) {
      this.addressData = {
        address_id: data.address_id,
        address_name: data.address_name
      }
      this.activeStep = 4;
    },
    fourthStepNextClick(data) {
      this.specialInstructions = data.specialInstructions;
      this.activeStep = 5;
    },
    fifthStepNextClick(qty) {
      this.allocation_qty = qty;
      let data = {
        // CRAFT_CSRF_TOKEN: this.allocationData.csrf,
        address_id: this.addressData.address_id,
        address_name: this.addressData.address_name,
        allocation_qty: this.allocation_qty
      }
      
      if (this.poData.po_required) {
        data.po_number = this.poData.po_number;
        data.poDate = this.poData.poDate;
      }
      data.po_required = this.poData.po_required;
      data.specialInstructions = this.specialInstructions;

      this.localStorageData.push(data);
      this.setDataToLocalStorage();
      this.goToStep(1);
    },
    updatedAvailableQty(data) {
      console.log('updatedAvailableQty', data);
    },
    goToStep(index) {
      this.activeStep = index;
    },
    stepCancelClick() {
      this.activeStep = 1;
    },
    setDataToLocalStorage() {
      let data = localStorage.getItem('allocation');
      if (data) {
        data = JSON.parse(data);
      } else {
        data = {};
      }
      data['' + this.allocationData.id] = this.localStorageData;
      localStorage.setItem('allocation', JSON.stringify(data));

      this.updateRemainingItems();
    },
    getDataFromLocalStorage() {
      let data = localStorage.getItem('allocation');
      let currentData = [];
      if (data) {
        data = JSON.parse(data);
        if (data.hasOwnProperty('' + this.allocationData.id)) {
          currentData = data['' + this.allocationData.id];
        }
      }
      this.localStorageData = currentData;
      this.updateRemainingItems();
    },
    finishAllocated() {
      let hasError = this.checkRemainsItems();

      if(!hasError){
        if (this.canSend) {
          this.canSend = false;
          sendOrder(this.allocationData.id, {
            CRAFT_CSRF_TOKEN: this.allocationData.csrf,
            data:this.localStorageData
          }).then(
              (res) => {
                console.log(res);
                if (res.status === 200) {
                  this.localStorageData = [];
                  this.setDataToLocalStorage();
                  this.canSend = true;

                  this.showFinishAllocationPopup = true;
                  // document.location.reload();
                }

              },
              (error) => {
                console.log(error);
              }
          )
        }
      }
    },
    deleteLocalItem(index){
      this.errorArray = [];
      this.localStorageData.splice(index,1);
      this.setDataToLocalStorage();
    },
    updateLocalItem(index){
      this.errorArray = [];
      this.popupVisible = true;
      this.updateItemIndex = index;
      this.currentAllocatedData = this.localStorageData[index];
      // this.currentAllocatedItems = this.
    },
    onSave(qty){
      this.localStorageData[this.updateItemIndex].allocation_qty = qty;
      this.setDataToLocalStorage();
      this.popupVisible = false;
    },
    onCancel(){
      this.popupVisible = false;
    },
    updateRemainingItems() {
      console.log('updateRemainingItems');

      this.allocationData.lineItems.forEach(lineItem => {
        lineItem.remains = lineItem.qty - lineItem.allocated;
      });

      this.localStorageData.forEach(allocation => {
        for (const key in allocation.allocation_qty) {
          const allocatedItem = this.allocationData.lineItems.find(item => item.id == key)
          allocatedItem.remains -= allocation.allocation_qty[key]
        }
      });
    },
    checkRemainsItems(){
      this.errorArray = [];

      this.allocationData.lineItems.forEach(item => {
        if (item.remains < 0) {
          this.errorArray.push(item.title + '- Allocated quantity is bigger than remaining for allocation ');
        }
      })

      return this.errorArray.length > 0;
    },
    onContinueFinishAllocationPopup(){
      location.href = '/rd';
    },
    closeFinishAllocationPopup(){
      this.showFinishAllocationPopup = false;
      document.location.reload();
    }
  }
}
</script>